module.exports = __webpack_public_path__ + "static/media/ploni-ultrabold-aaa.3d553855.eot";